import { ModelFactory } from "../../ModelFactory";
export class SiteOptimizeReport {
  constructor(
    public readonly domain: string,
    public readonly isLive: boolean,
    public readonly canSetLive: boolean,
    public readonly isOptimized: boolean,
    public readonly canBeOptimized: boolean,
  ) {
  }
}

class SiteOptimizeReportFactory extends ModelFactory<SiteOptimizeReport> {
  protected fromJson(json: any): SiteOptimizeReport {
    return new SiteOptimizeReport(
      json['domain'],
      json['is_live'],
      json['can_set_live'],
      json['is_optimized'],
      json['can_be_optimized'],
    );
  }
}
export const siteOptimizeReportFactory = new SiteOptimizeReportFactory();
